{
  "editor": {
    "headingNew": "New note",
    "headingAmend": "Correct the note",
    "noteType": "Note type",
    "sign": "Sign",
    "signing": "Signing…",
    "cancel": "Cancel",
    "close": "Close",
    "nothingSaved": "Nothing is saved until you sign. There is no draft — leave this screen and the text is gone.",
    "amendExplanation": "The correction becomes version {version}. The current version is not removed; it stays in the record.",
    "signedIrreversible": "A signed note cannot be removed. Mistakes are corrected by writing a new version.",
    "discardQuestion": "Close the note? The text you have written will not be saved.",
    "discardConfirm": "Close without saving",
    "discardCancel": "Keep writing",
    "signedOk": "The note is signed and is in the record.",
    "amendedOk": "The correction is signed as version {version}. The earlier version stays in the record.",
    "reload": "Reload the note",
    "language": "Language of the note",
    "languageChoose": "Choose a language …"
  },
  "action": {
    "write": "Write a note",
    "amend": "Correct the note",
    "showVersions": "Show all versions",
    "hideVersions": "Hide versions"
  },
  "history": {
    "heading": "Versions",
    "loading": "Reading versions…",
    "failed": "The versions could not be read.",
    "notFound": "That note is not in the record.",
    "retry": "Try again",
    "count": "{count, plural, one {# version} other {# versions}}",
    "current": "Current version",
    "superseded": "Superseded by a later version"
  },
  "version": {
    "number": "Version {version}",
    "written": "Written into the record {time}",
    "signedBy": "Signed by {name}, {time}",
    "signedByWithTitle": "Signed by {title} {name}, {time}",
    "unsigned": "Not signed",
    "retracted": "Marked as entered in error",
    "clock": "Clock: {source}",
    "clockWithUncertainty": "Clock: {source}, stated accuracy ±{seconds} s",
    "empty": "This version has no text."
  },
  "clock": {
    "gps": "GPS",
    "ntp": "Time server",
    "rtc": "The box's own clock",
    "manual": "Set by hand"
  },
  "field": {
    "bodyText": "Free text"
  },
  "fieldHint": {
    "subjective": "What the patient reports.",
    "objective": "Examination findings and measurements.",
    "assessment": "Your assessment.",
    "plan": "How care continues.",
    "bodyText": "For what does not fit the SOAP fields. Fill in the SOAP fields, the free text, or both."
  },
  "refusal": {
    "empty": "The note is empty. Write in at least one field before signing.",
    "typeMissing": "Choose a note type.",
    "typeInvalid": "That note type is not accepted. Choose one from the list.",
    "fieldTooLong": "{field} is too long. Shorten it to at most {maximum} characters.",
    "languageInvalid": "That language code is not accepted. The note was not written.",
    "versionStale": "Somebody else corrected this note while you were writing. Your text is still here — read the new version and write your correction against it.",
    "retracted": "The note is marked as entered in error and cannot be corrected.",
    "clientMismatch": "The note was not written because of a technical fault. Try again.",
    "noteNotFound": "That note is no longer there to correct.",
    "patientNotFound": "That patient is not in the record.",
    "unknown": "The note was not written. Try again.",
    "unavailable": "No contact with the server. The note was not written — leave this window open and try again.",
    "languageMissing": "Choose the language the note is written in. The note was not signed."
  },
  "forensic": {
    "badge": "Forensically relevant",
    "mark": "Mark as forensically relevant",
    "marking": "Marking …",
    "withdraw": "Remove the marker",
    "withdrawing": "Removing …",
    "explanation": "The marker lets the note be found in a later investigation, for example into violence or abuse. It says nothing about what happened.",
    "refused": "The marker could not be saved. The overview is updated — try again.",
    "unavailable": "No contact with the server. Open the patient overview again and check whether the marker is there before trying again.",
    "confirmQuestion": "Remove the marker? The removal is saved in the record under your name, and the marker remains as an earlier version.",
    "confirmWithdraw": "Yes, remove the marker",
    "keep": "Keep the marker"
  }
}
